import React, { useState } from "react";
import { homeAboutData } from "../../thirdUtils/constant";
import img1 from "../../thirdAssets/Images/aboustusVideoImg.jpg"
import img2 from "../../thirdAssets/Images/aboutusImg.jpg"

const HomeAbout = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [hoveredIndex, setHoveredIndex] = useState(null);
    return (
        <>
            <div className="third-design-home-about-container">
                <div className="third-design-home-about-left-div">
                    <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">{selectedLanguage?.txt_about_us}</h2>
                    <h1>{selectedLanguage?.txt_best_dental_clinic}</h1>
                    <p>{selectedLanguage?.txt_it_is_very_important}
                    </p>
                    {
                        homeAboutData?.map((v, i) => {
                            return (
                                <div key={i}
                                    onMouseEnter={() => setHoveredIndex(i)}
                                    onMouseLeave={() => setHoveredIndex(null)}>
                                    <div className={i === 0 ? "third-design-home-about-left-img-div third-design-home-about-left-theme-clr-img" : "third-design-home-about-left-img-div"}>
                                        <img src={hoveredIndex === i ? v?.greenImg : v?.whiteImg} alt="" />
                                    </div>
                                    <div className="third-design-home-about-left-text-div">
                                        <h2>
                                            {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                        </h2>
                                        <p>
                                            {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="third-design-home-about-right-div">
                    <div data-aos="fade-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500" className="third-design-home-about-right-img-1">
                        <img src={img1} alt="" />
                    </div>
                    <div data-aos="fade-down"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500" className="third-design-home-about-right-img-2">
                        <img src={img2} alt="" />
                        <button>{selectedLanguage?.txt_learn_about_us}</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default HomeAbout